import React from 'react';
import { Box, Skeleton, Stack, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const EventSkeleton = () => {
  return (
    <Box sx={{ p: 2 }}>
      {/* Header bar with back-button and badge */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <IconButton disabled>
          {/* Use a circular skeleton for the icon */}
          <Skeleton variant="circular" width={40} height={40} />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        {/* Badge placeholder */}
        <Skeleton variant="rounded" width={100} height={32} />
      </Box>

      {/* Hero image area */}
      <Skeleton 
        variant="rectangular" 
        width="100%" 
        // adjust height to match your real hero image aspect ratio
        height={300} 
        sx={{ borderRadius: 2, mb: 3 }} 
      />

      {/* Title and subtitle */}
      <Stack spacing={1} mb={2}>
        <Skeleton variant="text" width="40%" height={32} />
        <Skeleton variant="text" width="25%" height={24} />
      </Stack>

      {/* Registration button */}
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="rectangular" width={150} height={48} />
      </Box>

      {/* Some additional lines to represent other details/cards */}
      <Stack spacing={1}>
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="60%" />
        <Skeleton variant="rectangular" width="100%" height={120} sx={{ borderRadius: 1 }} />
      </Stack>
    </Box>
  );
};

export default EventSkeleton;
